class CollapsibleHeader extends Collapsible {
  constructor() {
    super();
    this.header = this.closest('[data-header]');
    this.headerWrapper = this.closest('.shopify-section-group-header-group');

    if (!this.header) {
      return;
    }
    this.inverse = !!this.header.classList.contains('header--inverse');
    this.shadow = this.header.querySelector('.header-shadow');
    this.backdrop = document.querySelector('.header__backdrop');

    // extra events
    this.shadow?.addEventListener('click', this.closeAll.bind(this));

    // on key up
    document.addEventListener('keyup', (event) => {
      this.onKeyUp(event);
    });

    //Close menu on resize
    window.addEventListener('resize', () => {
      this.closeAll();
    });

    // Open menu event for getting nav container height
    this.levelOneElements = this.header.querySelectorAll('[data-level-1]');
    if (this.levelOneElements) {
      console.log('levelOneElements', this.levelOneElements);
      this.levelOneElements.forEach((levelOne) => {
        let navContainer = levelOne.querySelector('.header__navigation-container');
        levelOne.addEventListener('click', (event) => {
          console.log('testing click', event);
          if (
            event.target !== levelOne &&
            event.target.parentElement !== levelOne &&
            event.target.parentElement.parentElement !== levelOne
          )
            return;

          this.levelTwoElements = levelOne.querySelectorAll('[data-level-2]');
          this.levelTwoElements.forEach((levelTwo, index) => {
            levelTwo.classList.remove('collapsible-is-open');
            console.log('levelTwo', levelTwo);
            if (index == 0) {
              console.log('index0');
              levelTwo.classList.add('collapsible-is-open');
              this.setNavContainerHeight(levelTwo, navContainer);
            }
          });
        });

        this.levelTwoElements = levelOne.querySelectorAll('[data-level-2]');
        this.levelTwoElements.forEach((levelTwo) => {
          levelTwo.addEventListener('click', (event) => {
            this.levelTwoElements.forEach((el) => el.classList.remove('collapsible-is-open'));
            levelTwo.classList.add('collapsible-is-open');
            this.setNavContainerHeight(levelTwo, navContainer);
          });
        });
      });
    }

    // Close menu when clicking on the backdrop
    this.backdrop?.addEventListener('click', this.closeAll.bind(this));
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  onKeyUp(event) {
    if (!document.body.classList.contains('header-is-open')) {
      return;
    }
    if (event?.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass } = this.options;
    let group = this.querySelector(`[data-collapsible-group].${toggleClass}`);
    if (group) {
      this.close(group);
    }
  }

  open(group) {
    if (group.classList.contains('collapsible-is-open')) {
      this.close(group);
      return;
    }
    super.open(group);

    // Custom behavior for CollapsibleHeader
    if (this.headerWrapper) document.body.classList.add('header-is-open');
    this.toggleHeaderClass(true);

    // Additional logic can be added here if needed
  }

  close(group) {
    super.close(group);
    if (this.headerWrapper) document.body.classList.remove('header-is-open');
    this.toggleHeaderClass(false);
  }

  toggle(group) {
    super.toggle(group);
  }

  closeSiblings(currentGroup = null) {
    super.closeSiblings(currentGroup);
    this.toggleHeaderClass(false);
  }

  openAll() {
    super.openAll();
    this.toggleHeaderClass(true);
    if (this.headerWrapper) document.body.classList.add('header-is-open');
  }

  closeAll() {
    super.closeAll();
    this.toggleHeaderClass(false);
    if (this.headerWrapper) document.body.classList.remove('header-is-open');
  }

  toggleHeaderClass(open = true) {
    if (!this.header) return false;

    if (open) {
      document.body.classList.add('header-is-open');
      this.inverse && this.header.classList.add('header-inverse-solid');
    } else {
      let close = true;
      this.groups.forEach((group) => {
        if (group.classList.contains(this.options.toggleClass)) {
          close = false;
        }
      });
      if (close) {
        document.body.classList.remove('header-is-open');
        this.inverse && document.body.classList.remove('header-inverse-solid');
      }
    }
  }

  setNavContainerHeight(levelTwo, navContainer) {
    console.log('setNavContainerHeight', levelTwo, navContainer);
    navContainer.style.minHeight = '';
    this.levelThreeWrapper = levelTwo.querySelector('[data-level-3]');
    let minHeight = this.levelThreeWrapper.scrollHeight;
    navContainer.style.minHeight = minHeight + 40 + 'px';
    this.levelThreeWrapper.style.minHeight = minHeight + 'px';
    console.log('setNavContainerHeight', navContainer, minHeight);
  }
}

class ToggleMobileNavigation extends ToggleElementClass {
  constructor() {
    super();

    this.header = this.closest('[data-header]');

    if (this.header) {
      this.shadow = this.header.querySelector('.header-shadow');
      this.inverse = !!this.header.classList.contains('header--inverse');

      // Extra events
      document.addEventListener('keyup', (event) => {
        this.onKeyUp(event);
      });

      this.shadow?.addEventListener('click', (event) => {
        this.remove(event);
      });
    }
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  onKeyUp(event) {
    if (!document.body.classList.contains('menu-drawer-is-open')) {
      return;
    }
    if (event?.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    trapFocus(this.header);
  }

  remove() {
    super.remove();
    this.closeAllSiblings();
    removeTrapFocus();
  }

  closeAllSiblings() {
    const collapsibles = this.target.querySelector('collapsible-element');
    collapsibles.closeAll();
  }
}

class ToggleSearch extends ToggleElementClass {
  constructor() {
    super();
  }

  construct() {
    super.construct();

    // elements
    this.header = this.closest('[data-header]');

    // options
    const { toggleClass, target } = this.options;

    // key up escape
    document.addEventListener('keyup', (event) => {
      this.onKeyUp(event);
    });

    // Remove classes in case the header navigation drawer is open.
    this.addEventListener('click', () => {
      document.body.classList.remove('header-is-open');
      document.body.classList.remove('menu-drawer-is-open');
      // Focus on input element if provided
      if (this.options.focusTarget) {
        document.querySelector(this.options.focusTarget)?.focus();
      }
    });
  }

  onKeyUp(event) {
    if (!document.body.classList.contains('header-search-is-open')) {
      return;
    }
    if (event?.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    if (this.header) {
      document.body.classList.add('header-search-is-open');
    }
    if (this.target) {
      trapFocus(this.target);
    }
  }

  remove() {
    super.remove();
    if (this.header) {
      document.body.classList.remove('header-search-is-open');
    }
    removeTrapFocus();
  }
}

class StickyHeader extends HTMLElement {
  constructor() {
    super();

    // select element
    this.headerElement = this;
    this.header = document.querySelector('[data-header]');
    this.headerWrapper = document.querySelector('.shopify-section-group-header-group');
    this.announcementBar = document.querySelector('#shopify-section-announcement-bar');
    this.headerInverse = !!this.headerElement.classList.contains('header--inverse');
    this.headerNav = this.querySelector('collapsible-header');
    this.mobileNav = this.querySelector('toggle-mobile-navigation');
    this.search = this.querySelector('[data-header-search]');
    this.searchToggle = this.querySelector('toggle-search');
    this.productInfo = document.querySelector('[data-product-info]');

    if (this.headerWrapper) {
      // scroll parameters
      this.currentScrollTop = 0;
      this.scrollOffset = 0;
      this.headerStart = 0;

      if (this.announcementBar) {
        const announcementBarHeight = this.announcementBar.offsetHeight;
        this.scrollOffset += announcementBarHeight;
        this.headerStart += announcementBarHeight;
      }

      if (this.headerElement) {
        this.scrollOffset += this.headerElement.offsetHeight;
      }

      // scroll event
      this.raf = null; // Safe request animation frame
      (this.timer = null), // Safe scroll timer
        window.addEventListener(
          'scroll',
          () => {
            clearTimeout(this.timer);
            if (!this.raf) {
              // A request animation frame is used to animate on max 60fps.
              this.raf = requestAnimationFrame(this.scrollAnimation.bind(this));
            }
            this.timer = setTimeout(() => {
              // Stop animation, cancel request animation frame
              cancelAnimationFrame(this.raf);
              this.raf = null;
            }, 50);
          },
          false
        );
    }
  }

  scrollAnimation() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    // only animate if header is closed.
    if (!document.body.classList.contains('header-is-open')) {
      if (scrollTop + window.innerHeight > document.body.clientHeight) {
        this.hide();
      } else if (scrollTop > this.currentScrollTop && scrollTop > this.scrollOffset) {
        this.hide();
      } else if (scrollTop <= this.headerStart) {
        this.revealTop();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerStart) {
        this.reveal();
      }
    }

    this.currentScrollTop = scrollTop;

    // Recall request animation loop
    this.raf = requestAnimationFrame(this.scrollAnimation.bind(this));
  }

  hide() {
    document.body.classList.add('header-hidden', 'header-sticky');
    this.closeHeaderNav();
    // this.closeMobileNav();
    this.closeSearch();
    this.productInfoPosition('up');
  }

  reveal() {
    document.body.classList.add('header-sticky');
    if (this.headerInverse) {
      document.body.classList.add('header-inverse-solid');
    }
    this.productInfoPosition('down');
  }

  revealTop() {
    if (this.headerInverse && !document.body.classList.contains('header-is-open')) {
      document.body.classList.remove('header-inverse-solid');
    }
    document.body.classList.remove('header-hidden', 'header-sticky');
    this.productInfoPosition('up');
  }

  closeHeaderNav() {
    if (!this.headerNav || window.innerWidth < 768) {
      return false;
    }
    this.headerNav.closeAll();
  }

  closeMobileNav() {
    if (!this.mobileNav) {
      return false;
    }
    // this.mobileNav.remove();
  }

  closeSearch() {
    if (!this.search || !this.searchToggle) {
      return false;
    }
    if (this.search.classList.contains('header__search--is-active')) {
      this.searchToggle.remove();
    }
  }

  productInfoPosition(pos = 'up') {
    if (!this.productInfo) {
      return;
    }
    if (pos == 'down') {
      this.productInfo.classList.replace('top-0', 'top-[4.5rem]');
    } else {
      this.productInfo.classList.replace('top-[4.5rem]', 'top-0');
    }
  }
}

if (!customElements.get('collapsible-header')) {
  customElements.define('collapsible-header', CollapsibleHeader);
}

if (!customElements.get('toggle-mobile-navigation')) {
  customElements.define('toggle-mobile-navigation', ToggleMobileNavigation);
}

if (!customElements.get('toggle-search')) {
  customElements.define('toggle-search', ToggleSearch);
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}
